import { isB2B } from '@/domains/core/settings/utils';
import { useAuth } from '@/domains/customerManagement/auth/hooks/useAuth';
import { AddToWishList } from '@/domains/proB2BServices/AddToWishlist/AddToWishList';

type Props = {
  shouldDisablePurchase?: boolean;
};

export const WishlistButton = ({ shouldDisablePurchase = false }: Props) => {
  const { isAuthenticated, isGuest } = useAuth();

  const isAuthValid = isAuthenticated && !isGuest;
  const showWishlistButtons = isB2B() || isAuthValid;

  if (!showWishlistButtons || shouldDisablePurchase) {
    return null;
  }

  return (
    <div
      className="absolute right-m top-m z-[1] desktop:relative desktop:right-0
        desktop:top-0"
    >
      <AddToWishList />
    </div>
  );
};
